import { z } from 'zod';
import { CLIENT_TYPES } from './events.js';
/** Алфавит кодов комнат: без похожих символов (0/O, 1/I/L). */
export const ROOM_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
export const ROOM_CODE_LENGTH = 6;
const ROOM_CODE_PATTERN = new RegExp(`^[${ROOM_CODE_ALPHABET}]{${ROOM_CODE_LENGTH}}$`);
/** Токен восстановления сессии: 32 случайных байта в base64url. */
const RESUME_TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;
export const ROOM_MODES = ['versus', 'coop'];
export const PLAYER_ROLES = ['pilot', 'strategist'];
/** Боссы для игры вдвоём (совпадают с BOSS_IDS из game-core; проверяется тестом сервера). */
export const BOSS_IDS = ['spornitsa', 'grippozavr', 'vibrion', 'tuberkul', 'chimera'];
/** Выбор способностей Versus перед матчем (SPEC.md 15.2): слот C и слот V. */
export const VERSUS_C_ABILITIES = ['cryo', 'antibiotic'];
export const VERSUS_V_ABILITIES = ['fever', 'immunity'];
export const displayNameSchema = z
    .string()
    .trim()
    .min(1)
    .max(20)
    .regex(/^[^\p{Cc}\p{Cf}]+$/u, 'управляющие символы запрещены');
export const handshakeAuthSchema = z.strictObject({
    protocolVersion: z.number().int().nonnegative(),
    clientType: z.enum(CLIENT_TYPES),
});
export const createRoomSchema = z.strictObject({
    mode: z.enum(ROOM_MODES),
    name: displayNameSchema.optional(),
    /** Бой с боссом; без поля — классический матч. */
    bossId: z.enum(BOSS_IDS).optional(),
});
export const joinRoomSchema = z.strictObject({
    roomCode: z.string().trim().toUpperCase().regex(ROOM_CODE_PATTERN, 'неверный код комнаты'),
    name: displayNameSchema.optional(),
});
export const readySchema = z.strictObject({
    ready: z.boolean(),
});
export const selectRoleSchema = z.strictObject({
    role: z.enum(PLAYER_ROLES),
});
export const emptySchema = z.strictObject({});
export const selectLoadoutSchema = z.strictObject({
    abilities: z.tuple([z.enum(VERSUS_C_ABILITIES), z.enum(VERSUS_V_ABILITIES)]),
});
/** Действия игрока. Шаг гравитации (tick) выполняет только сервер — клиент его отправить не может. */
export const PLAYER_ACTIONS = [
    'move-left',
    'move-right',
    'rotate-clockwise',
    'rotate-counterclockwise',
    'soft-drop',
    'hard-drop',
    /** Способность слота C (в Co-op — способность своей роли). */
    'ability-c',
    /** Способность слота V (Versus). */
    'ability-v',
];
export const gameActionSchema = z.strictObject({
    matchId: z.uuid(),
    /** Уникальный идентификатор действия — для отбрасывания повторов. */
    actionId: z.string().regex(/^[A-Za-z0-9_-]{1,64}$/),
    /** Монотонный номер действия игрока в матче — для отбрасывания устаревших. */
    seq: z
        .number()
        .int()
        .min(0)
        .max(2 ** 31 - 1),
    action: z.strictObject({ type: z.enum(PLAYER_ACTIONS) }),
});
/** Выбор Стратегом следующей капсулы. pieceOptionId — «раунд-номер» из снимка матча. */
export const coopSelectPieceSchema = z.strictObject({
    matchId: z.uuid(),
    actionId: z.string().regex(/^[A-Za-z0-9_-]{1,64}$/),
    seq: z
        .number()
        .int()
        .min(0)
        .max(2 ** 31 - 1),
    pieceOptionId: z.string().regex(/^\d{1,6}-\d$/),
});
export const rematchSchema = z.strictObject({
    matchId: z.uuid(),
});
export const resumeSchema = z.strictObject({
    resumeToken: z.string().regex(RESUME_TOKEN_PATTERN, 'неверный токен'),
});
//# sourceMappingURL=schemas.js.map